import Vue from 'vue';
import ObjectUtils from '@/utils/object-utils';
import StringUtils from '@/utils/string-utils';
import Logger from '@/utils/logger.utils';

const EventBus = new Vue();
Vue.config.productionTip = false;
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: () => EventBus,
  },
});


const EventBusEmit = (event?: string) => (target: any, propertyKey: string, descriptor: PropertyDescriptor) => {
  propertyKey = StringUtils.hyphenate(propertyKey);
  const original = descriptor.value;
  descriptor.value = function emitter() {
    const args: Array<any> = [];
    /* eslint prefer-rest-params: 0 */
    for (let ii = 0; ii < arguments.length; ii++) {
      args[ii] = arguments[ii];
    }

    const emit = (rstValue: any) => {
      EventBus.$emit(event, rstValue);
      Logger.info(`The event: ${event} is fired!`);
    };

    const returnValue = original.apply(this, args);
    if (ObjectUtils.isPromise(returnValue)) {
      returnValue.then((rstValue: any) => {
        emit(rstValue);
      });
    } else {
      emit(returnValue);
    }
  };
};


export {
  EventBus,
  EventBusEmit,
};
